import { Box, Text, Button } from "@flexisaf/flexibull2";
import styled from "styled-components";
import EmptyIcon from "../../assets/emptystateicon.svg";

const QuizathonEmptyState = ({ action, title, desc, actionTitle }) => {
  return (
    <Container>
      <img
        src={EmptyIcon}
        alt="empty state icon"
        style={{ margin: "0 2.3rem 0 0"  }}
      />
      <Text
        bold
        size="16px"
        style={{
          textAlign: "center",
        }}
      >
        {title}
      </Text>
      <Text
        style={{
          textAlign: "center",
        }}
      >
        {desc}
      </Text>
      {actionTitle && (
        <Button onClick={action} >
          {actionTitle}
        </Button>
      )}
    </Container>
  );
};

export default QuizathonEmptyState;

const Container = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  margin: 4rem auto;
  max-width: 400px;
  gap: 1rem;
`;
